import { render, staticRenderFns } from "./AutopsyTab.vue?vue&type=template&id=75768acf&scoped=true"
import script from "./AutopsyTab.vue?vue&type=script&lang=js"
export * from "./AutopsyTab.vue?vue&type=script&lang=js"
import style0 from "./AutopsyTab.vue?vue&type=style&index=0&id=75768acf&prod&scoped=true&lang=css"
import style1 from "./AutopsyTab.vue?vue&type=style&index=1&id=75768acf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75768acf",
  null
  
)

export default component.exports